<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { getCurrentLocale } from '@/i18n';
import { usePromoComposable } from '../usePromoComposable';
import { formatDate } from '@/utils/dateUtils';
import { useDialog } from 'primevue/usedialog';
import Button from 'primevue/button';
import Fluid from 'primevue/fluid';
import InputText from 'primevue/inputtext';
import ManageConfigModal from '@/components/admin/ExpiryDateConfig/ManageConfigModal.vue';

interface Props {
  specialPromotionConfig: any;
  destinations: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  onSaveConfig: [value: any];
}>();

const dialog = useDialog();
const currentLanguage = getCurrentLocale();
const { t } = useI18n({ useScope: 'global' });
const { canEditConfigurableItem } = usePromoComposable();

const openModalEditConfig = () => {
  const dialogRef = dialog.open(ManageConfigModal, {
    props: {
      header: t('management.quote_config.promotion_config_edit_header'),
      modal: true,
      maximizable: true,
      style: {
        width: '55vw'
      },
      breakpoints: {
        '960px': '60vw',
        '640px': '90vw'
      }
    },
    data: {
      specialPromotionConfig: props.specialPromotionConfig,
      destinations: props.destinations
    },
    emits: {
      onClose: () => {
        dialogRef.close();
      },
      onSave: (data: any) => {
        emits('onSaveConfig', data);
      }
    }
  });
};

const displayDataDestinations = (destinations: any) => {
  const destCodeSelected = destinations.split(',');
  const destinationSelected = props.destinations
    .filter((dest: any) => {
      return destCodeSelected.includes(dest.code);
    })
    .map((dest: any) => dest.airportCode);

  return destinationSelected.length ? destinationSelected.join(' | ') : '';
};

const displayData = (data: string) => {
  return data ? data.split(',').join(' | ') : '';
};
</script>
<template>
  <div class="promotion-expiry-wrapper">
    <Fluid>
      <div class="grid mt-5" v-if="specialPromotionConfig.length">
        <p class="col-4 mb-0">{{ $t('management.package.brochure') }}</p>
        <p class="col-4 mb-0">{{ $t('common.destination') }}</p>
        <p class="col-4 mb-0">{{ $t('common.date') }}</p>
      </div>
      <div>
        <div class="grid field" v-for="(config, index) in specialPromotionConfig" :key="index">
          <div class="col-4">
            <InputText readonly :modelValue="displayData(config.brochures)"></InputText>
          </div>
          <div class="col-4">
            <InputText readonly :modelValue="displayDataDestinations(config.destinations)"></InputText>
          </div>
          <div class="col-4">
            <InputText readonly :modelValue="formatDate(config.expireDate, 'dd-LLL-yyyy', true, currentLanguage)"></InputText>
          </div>
        </div>
      </div>
    </Fluid>
    <div class="w-20 text-right">
      <Button v-if="canEditConfigurableItem" id="edit-config-btn" icon="pi pi-pencil" @click="openModalEditConfig()" :label="$t('common.buttons.edit')"></Button>
    </div>
  </div>
</template>
